<template>
  <div class="chrray-main" v-loading="this.$store.state.loading">
  <!-- <div class="chrray-main"> -->
    <sidebar @change="handleChange"></sidebar>
    <monitor-content></monitor-content>
  </div>
</template>

<script>
  import sidebar from "./sidebar";
  import monitorContent from './content';
  import common from "./mixin/common";
  import { mapActions } from 'vuex';
  export default {
    name: "monitorIndex",
    mixins: [common],
    data() {
      return {
        device: null,
      }
    },
    components: {
      sidebar,
      monitorContent
    },
    computed: {

    },
    mounted() {
      this._getDangerList();
    },
    methods: {
      //  vuex方法
      ...mapActions([
        '_getDangerList'
      ]),
      handleChange(item) {
        this.device = item;
      }
    }
  }
</script>

<style scoped lang="scss">
.chrray-main {
  display: flex;
  background-color: #f2f2f2;
  height: 100%;
}
</style>